export const globals = {
  maxWidth: "1024px",
  headerHeight: "75px",
  themeTransitionDuration: ".35s",
}
